module.exports = __webpack_public_path__ + "img/account.2593281a.svg";